module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-server-messages text-center"
  }, [(_vm.messages.success.length) ? _c('ul', {
    staticClass: "form-server-messages-list"
  }, _vm._l((_vm.messages.success), function(message) {
    return _c('li', {
      staticClass: "form-success-messages"
    }, [_vm._v(_vm._s(message))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.messages.errors.length) ? _c('ul', {
    staticClass: "form-server-messages-list"
  }, _vm._l((_vm.messages.errors), function(error) {
    return _c('li', {
      staticClass: "form-errors"
    }, [_vm._v(_vm._s(error))])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44ba7e7f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FormMessages.vue
// module id = 981
// module chunks = 0